// @flow
export default function inBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}



// WEBPACK FOOTER //
// ./src/utils/inBrowser.js